import type { UnwrapNestedRefs } from 'vue';
import type { GIMovie } from 'src/models/geoItem';
import type { MovieTag } from 'src/models/movie';
import type { MoviePlayerState } from 'src/models/moviePlayer';
import { updateMovieTags as updateMovieTagsHelper } from 'src/lib/moviePlayerHelper';

interface Deps {
  pauseUI: () => void;
}

interface MoviePlayerTagModalContext {
  startEditMovieTags: () => Promise<void>;
  updateMovieTags: (resultTags: MovieTag[]) => void;
}

export function useMoviePlayerTagModal(
  state: UnwrapNestedRefs<MoviePlayerState>,
  deps: Deps,
): MoviePlayerTagModalContext {
  const startEditMovieTagsOfMovie = (movie: GIMovie) => {
    deps.pauseUI();
    state.ui.movieTagModal.movie = movie;
    state.ui.movieTagModal.tags = movie.tags;
    state.ui.movieTagModal.show = true;
  };
  const startEditMovieTags = async() => {
    if (!state.movieList.current.currentMovie) return;

    startEditMovieTagsOfMovie(state.movieList.current.currentMovie);
  };
  const updateMovieTags = (resultTags: MovieTag[]) => {
    if (!state.ui.movieTagModal.movie) return;

    updateMovieTagsHelper(resultTags, state.ui.movieTagModal.movie);
    state.ui.movieTagModal.show = false;
  };

  return {
    startEditMovieTags,
    updateMovieTags,
  };
}
